
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/Layout/AppSidebar";
import { AppBreadcrumbs } from "@/components/Layout/AppBreadcrumbs";
import { AuthProvider } from "@/contexts/AuthContext";
import { PrivateRoute } from "@/components/PrivateRoute";
import { SuperAdminRoute } from "@/components/SuperAdminRoute";
import Dashboard from "./pages/Dashboard";
import FunnelBuilder from "./pages/FunnelBuilder";
import PublicFunnelPreview from "./pages/PublicFunnelPreview";
import PaymentSuccess from "./pages/PaymentSuccess";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";

const queryClient = new QueryClient();

const App = () => {
  // Check if we're on a subdomain or custom domain
  const host = window.location.host;
  const isSubdomain = host.split('.').length > 2;
  const domain = isSubdomain ? host.split('.')[0] : host;

  console.log('Routing debug:', { host, isSubdomain, domain });

  // If we're on a subdomain or custom domain, show the funnel preview
  if ((isSubdomain && domain !== 'www' && domain !== 'preview--pageflo' && !domain.includes('-') && domain !== 'pageflo') || 
      (!isSubdomain && host !== 'pageflo.app' && host !== 'localhost:5173')) {
    return (
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner position="top-right" closeButton richColors />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<PublicFunnelPreview subdomain={domain} />} />
                <Route path="/:slug" element={<PublicFunnelPreview subdomain={domain} />} />
                <Route path="/:slug/:postId" element={<PublicFunnelPreview subdomain={domain} />} />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner position="top-right" closeButton richColors />
          <BrowserRouter>
            <Routes>
              <Route path="/f/:subdomain" element={<PublicFunnelPreview />} />
              <Route path="/f/:subdomain/:slug" element={<PublicFunnelPreview />} />
              <Route path="/f/:subdomain/:blogPageSlug/:postSlug" element={<PublicFunnelPreview />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/superadmin" element={
                <SuperAdminRoute>
                  <SuperAdminDashboard />
                </SuperAdminRoute>
              } />
              <Route
                path="*"
                element={
                  <SidebarProvider>
                    <PrivateRoute>
                      <div className="min-h-screen w-full bg-gradient-to-br from-slate-50 to-slate-100/80">
                        <AppSidebar />
                        <main className="flex-1 overflow-auto">
                          <div className="container py-4">
                            <AppBreadcrumbs />
                            <Routes>
                              <Route path="/" element={<Dashboard />} />
                              <Route path="/funnels/:slug" element={<FunnelBuilder />} />
                            </Routes>
                          </div>
                        </main>
                      </div>
                    </PrivateRoute>
                  </SidebarProvider>
                }
              />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
